/**
 * Vuex
 *
 * @library
 *
 * https://vuex.vuejs.org/en/
 */

// Lib imports
import Vue from 'vue'
import Vuex from 'vuex'

// Store Functionality
import actions from './actions'
import getters from './getters'
import modules from './modules'
import mutations from './mutations'
import plugins from './plugins'
import state from './state'

Vue.use(Vuex)

// Create a new store
const store = new Vuex.Store({
  plugins,
  modules,
  actions,
  getters,
  mutations,
  state
})

export default store
